'use strict';
// allows for dynamic field names in Angular 1.2
// This is neccessary because we have dynamic fields coming in from the custom signups.
// Old-angular doesn't support angular-style markup in the name attribute.
// WARNING This depends on field.name being on the scope.
// http://stackoverflow.com/a/24470458/2108024

angular.module('msUtility').directive('fieldNameHack', function () {
  return {
    restrict: 'A',
    require: ['ngModel'],
    priority: -1,
    link: function link(scope, ele, attrs, ctrls) {
      // the field that we're using to generate the name is in the scope
      ele[0].name = scope.field.name;
      ctrls[0].$name = scope.field.name;
    }
  };
});